import { render, staticRenderFns } from "./MandateDetailsBulk.vue?vue&type=template&id=5fb0f5c8&scoped=true&%23pageContent=true&"
import script from "./MandateDetailsBulk.vue?vue&type=script&lang=js&"
export * from "./MandateDetailsBulk.vue?vue&type=script&lang=js&"
import style0 from "./MandateDetailsBulk.vue?vue&type=style&index=0&id=5fb0f5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0f5c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb0f5c8')) {
      api.createRecord('5fb0f5c8', component.options)
    } else {
      api.reload('5fb0f5c8', component.options)
    }
    module.hot.accept("./MandateDetailsBulk.vue?vue&type=template&id=5fb0f5c8&scoped=true&%23pageContent=true&", function () {
      api.rerender('5fb0f5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandateDetailsBulk.vue"
export default component.exports